import axios from 'axios'

import config from '../../config'

const updateInspectionType = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/InspectionTypes`
  return axios.put(url, data)
}

export default updateInspectionType
